export default "__VITE_ASSET__BP_WRLB9__"